var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",attrs:{"id":"dashboard_wrap"}},[_c('ForumList',{attrs:{"category":"latest"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }